import { Controller } from "@hotwired/stimulus";

export default class ScrollController extends Controller {
  connect() {
    const messages = document.getElementById("chat-history");
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    this.observer.observe(messages, { childList: true, subtree: true });
    messages.scrollTop = messages.scrollHeight;
  }

  handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.tagName === 'TURBO-FRAME' && node.dataset.autoscrollBehavior) {
            this.resetScroll(node);
          }
        }
      }
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /** Custom function */
  resetScroll(turboFrame) {
    const messages = document.getElementById("chat-history");
    const bottomOfScroll = messages.scrollHeight - messages.clientHeight;
    const upperScrollThreshold = bottomOfScroll - 500;
    // Scroll down if we're not within the threshold
    if (messages.scrollTop === 0 || messages.scrollTop > upperScrollThreshold) {
      messages.scrollTop = turboFrame.parentNode.offsetHeight;
    }
  }
}
